import ActivityType from "@mapmycustomers/shared/types/entity/activities/ActivityType";

import NylasActivityItem from "@app/types/nylas/NylasActivityItem";

export const activityTypeToNylasActivityItem = ({ id, name }: ActivityType): NylasActivityItem => ({
  id,
  name,
});
